import { getRefreshUrl } from 'crm-events-components/internal/helpers/getRefreshUrl';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { WarningIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const options = {
  href: getRefreshUrl()
};
const elements = {
  Link
};
function ActivitySummaryError() {
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockStart: "400",
    children: /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      padding: "800",
      children: [/*#__PURE__*/_jsx(View, {
        as: "span",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(WarningIcon, {
          size: "800"
        })
      }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "timeline.activitySummary.error_jsx",
        elements: elements,
        options: options
      })]
    })
  });
}
export default ActivitySummaryError;